module.exports = __webpack_public_path__ + "img/chineseBanner2.7336c8ea.png";